export const CPlusPlus = () => {
  return <>
    <h1>R&D Junior / Senior Software Engineer</h1>
    <p>
      Hexagon is a global leader in sensor, software and autonomous solutions. We are putting data to work to boost
      efficiency, productivity, and quality across industrial, manufacturing, infrastructure, safety, and mobility
      applications. <br/>
      Our technologies are shaping urban and production ecosystems to become increasingly connected and autonomous —
      ensuring a scalable, sustainable future.
    </p>
    <p>
      The Luciad R&D team, part of Hexagon and located in Leuven, Belgium, is looking for a highly motivated and
      passionate Junior / Senior Software Engineer. <br/>
      This R&D team develops innovative software for visualizing, analyzing and managing geospatial data, such as
      satellite images, real-time air and marine traffic, weather data and 3D models of buildings and cities. <br/>
      Combining state-of-the-art software technology & computer graphics allow customers such as Airbus, Lufthansa
      Systems or BASF to convert large amounts of data into high-performance visual analyses in real-time. <br/>
      The software is also used to realize Smart Cities using a so-called Digital Twin: Hexagon sensors are used to
      create a digital version of a city in 3D that can be used in a visually interactive way to support
      decision-making.
    </p>
    <h2>Want to be part of a strong R&D team?</h2>
    <p>
      The R&D team in Leuven is at the core of the Luciad product portfolio, a suite of geospatial visualization and
      analysis software components. <br/>
      As an R&D Software Engineer, you are part of a 35+ team that creates software for high performance visualization
      and analysis of any kind of geospatial data: worldwide air traffic, maritime charts, 3D laser scans of entire cities, 
      weather maps, detailed multi-spectral satellite imagery, … <br/>
      We use computer graphics technologies, applied mathematics, web technology and of course plenty of software
      development technologies and best practices.
    </p>
    <p>
      Some examples of questions we were recently tasked with:
      <ul>
        <li>Build a solution that can access laser-scanned point clouds with billions of points in a browser.</li>
        <li>Research the application of augmented and virtual reality technology to enhance air traffic control
          operations.
        </li>
        <li>Show live high-resolution radar streams with low latency.</li>
      </ul>
    </p>
    <p>
      Our software relies on multiple languages, including JavaScript/TypeScript, Java, C++, and C#. <br/>
      Depending on your preferences, you can flexibly rotate from one area of technology to another.
    </p>
    <h2>Do you have a passion for technology and love writing code?</h2>
    <p>
      We are looking for a Junior / Senior Software Engineer with the following profile:
      <ul>
        <li>You have a good understanding of C++ and/or JavaScript/TypeScript development. 
          For senior positions, professional experience in at least one of these languages is required.
        </li>
        <li>You obtained a university degree in informatics or computer science, or equivalent through experience.</li>
        <li>You possess strong knowledge of object-oriented design & development.</li>
        <li>You contribute to all development aspects: planning, analysis, design, architecture, implementation,
          testing, documentation, support and maintenance.
        </li>
        <li>Experience with C# / .NET development is considered a plus.</li>
        <li>Experience with graphics APIs such as OpenGL or DirectX is considered a plus.</li>
        <li>You are a team player with a heart for agile software development. You are focused on quality and take
          ownership of your team’s work.
        </li>
        <li>You live in Belgium and in addition to English, fluent in at least one other European language.</li>
      </ul>
    </p>
    <h3>We offer</h3>
    <p>
      At Hexagon, we share a dynamic SME culture in an international context where diversity is our key factor of
      success. Our spirited energy and engagement are evident in our commitment to our work, passion for what we do and
      the speed by which we achieve it. <br/>
      Here you will find the opportunity to build your career, develop professionally, and explore opportunities across
      a large, diversified company that prides itself on its innovative spirit and commitment to integrity.
    </p>
    <p>
      Interested? Don't hesitate to mail your CV to <a
        href="mailto:jobs.luciad.gsp@hexagon.com">jobs.luciad.gsp@hexagon.com</a>.
    </p>
  </>
}